import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { sortStrings } from 'flow/utils/sorter-utils';
import { ActiveCallDirections, CallState, convertNumberToE164, prettyFormatE164Number } from 'flow/utils/call-utils';
import { prettyPersonalNumber } from 'flow/utils';
import { getOwnActiveCalls } from 'flow/selectors/call-selectors';
import { isURL } from './call-widget-utils';
var CONTACT_BAG_VARIABLE_KEY = 'CONTACT';
export var CallWidgetTypes = Object.freeze({
  BANKID_ON_DEMAND: 'bankidondemand'
});
export var validateProtocol = function validateProtocol(url) {
  return !!url && url.includes(':');
};
export var isTwelveDigitSocialSecurityNumber = function isTwelveDigitSocialSecurityNumber(socialSecurityNumber) {
  return /^[0-9]{12}$/.test(socialSecurityNumber);
};
export var isTenDigitSocialSecurityNumber = function isTenDigitSocialSecurityNumber(socialSecurityNumber) {
  return /^[0-9]{10}$/.test(socialSecurityNumber);
};
export var socialSecurityNumberToTwelveDigits = function socialSecurityNumberToTwelveDigits(socialSecurityNumber) {
  if (isTwelveDigitSocialSecurityNumber(socialSecurityNumber)) {
    return socialSecurityNumber;
  } else {
    return '';
  }
};
export var socialSecurityNumberToTenDigits = function socialSecurityNumberToTenDigits(socialSecurityNumber) {
  if (isTwelveDigitSocialSecurityNumber(socialSecurityNumber)) {
    return socialSecurityNumber.substr(2);
  } else if (isTenDigitSocialSecurityNumber(socialSecurityNumber)) {
    return socialSecurityNumber;
  } else {
    return '';
  }
};
export var socialSecurityNumberToTwelveDigitsWithDash = function socialSecurityNumberToTwelveDigitsWithDash(socialSecurityNumber) {
  if (isTwelveDigitSocialSecurityNumber(socialSecurityNumber)) {
    return prettyPersonalNumber(socialSecurityNumber);
  } else {
    return '';
  }
};
export var socialSecurityNumberToTenDigitsWithDash = function socialSecurityNumberToTenDigitsWithDash(socialSecurityNumber) {
  if (isTwelveDigitSocialSecurityNumber(socialSecurityNumber)) {
    return prettyPersonalNumber(socialSecurityNumber.substr(2));
  } else if (isTenDigitSocialSecurityNumber(socialSecurityNumber)) {
    return prettyPersonalNumber(socialSecurityNumber);
  } else {
    return '';
  }
};
var replaceURLVariable = function replaceURLVariable(braceDelimiters) {
  return function (url, variable, replaceValue) {
    var startDelimiter = braceDelimiters ? '{' : '%';
    var endDelimiter = braceDelimiters ? '}' : '%';
    return url.replace("".concat(startDelimiter).concat(variable).concat(endDelimiter), replaceValue);
  };
};
export var populateUrl = function populateUrl(url, bagVariables) {
  if (!url) {
    return null;
  }
  var braceDelimiters = url.includes('{');
  var variableMatches = braceDelimiters ? url.matchAll(/{(.*?)}/g) : url.matchAll(/%(.*?)%/g);
  var replace = replaceURLVariable(braceDelimiters);
  var _iterator = _createForOfIteratorHelper(variableMatches),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var match = _step.value;
      var variable = match[1];
      if (bagVariables && variable in bagVariables) {
        // Don't encode URI components if it's already a URL. Allows for passing entire URLs as variables
        var encode = !isURL(bagVariables[variable]);
        var value = encode ? encodeURIComponent(bagVariables[variable]) : bagVariables[variable];
        url = replace(url, variable, value);
        continue;
      }
      var dotIndex = variable.indexOf('.');
      if (dotIndex && bagVariables) {
        var bagKey = variable.substring(0, dotIndex);
        var jsonPath = variable.substring(dotIndex + 1);
        try {
          var bagValue = _typeof(bagVariables[bagKey]) === 'object' ? bagVariables[bagKey] : JSON.parse(bagVariables[bagKey]);
          var _value = jsonPath.split('.').reduce(function (object, key) {
            return object[key];
          }, bagValue);
          if (_value !== undefined) {
            // Don't encode URI components if it's already a URL. Allows for passing entire URLs as variables
            var _encode = !isURL(_value);
            _value = _typeof(_value) === 'object' ? JSON.stringify(_value) : _value;
            _value = _encode ? encodeURIComponent(_value) : _value;
            url = replace(url, variable, _value);
            continue;
          }
        } catch (_e) {
          // don't throw
        }
      }
      url = replace(url, variable, '');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return url;
};
var populateUrlList = function populateUrlList(urlList, bagVariables) {
  urlList = urlList || [];
  urlList.forEach(function (_ref, index) {
    var url = _ref.url;
    urlList[index].url = populateUrl(url, bagVariables);
  });
  return urlList;
};
export var getSortedCallWidgetUrls = function getSortedCallWidgetUrls(callWidgets) {
  return callWidgets && Object.values(callWidgets.toList().toJS()).sort(function (a, b) {
    return sortStrings(a && a.title, b && b.title);
  });
};
export var getSortedExternalSearchCallWidgetUrlsWithPhoneNumbers = function getSortedExternalSearchCallWidgetUrlsWithPhoneNumbers(callWidgets, bagVariables) {
  if (!callWidgets) {
    return [];
  }
  var sortedList = getSortedCallWidgetUrls(getExternalSearchWidgets(callWidgets));
  return populateUrlList(sortedList, bagVariables);
};
export var getSortedExternalSearchCallWidgetUrlsBasedOnNumber = function getSortedExternalSearchCallWidgetUrlsBasedOnNumber(callWidgets, bagVariables) {
  if (!callWidgets) {
    return [];
  }
  var sortedList = getSortedCallWidgetUrls(getExternalSearchWidgetsForContextMenu(callWidgets));
  return populateUrlList(sortedList, bagVariables);
};
export var getNumberInRunUrlFriendlyFormat = function getNumberInRunUrlFriendlyFormat(number, loggedInUserCountryCode) {
  /**
   * Converting number to e164 format if possible
   */
  var e164Number = convertNumberToE164(number, loggedInUserCountryCode);

  /**
   * Formatting to national number if number is from the same country as relativeCountryCode
   */
  var numberPrettyFormatted = prettyFormatE164Number(e164Number, loggedInUserCountryCode) || '';

  /**
   * Removing characters that are not digits or not the + character,
   * so that 33 00 45 99 is formatted to 33004599, 0762-11 22 33 is formatted to 0762112233, etc...
   */
  return numberPrettyFormatted.replace(/[^0-9+]/g, '');
};
export var getE164NumberInRunUrlFriendlyFormat = function getE164NumberInRunUrlFriendlyFormat(number, loggedInUserCountryCode) {
  /**
   * Converting number to e164 format if possible
   */
  var e164Number = convertNumberToE164(number, loggedInUserCountryCode) || '';

  /**
   * Removing characters that are not digits or not the + character,
   * so that 33 00 45 99 is formatted to 33004599, 0762-11 22 33 is formatted to 0762112233, etc...
   */
  return e164Number.replace(/[^0-9+]/g, '');
};
export var getBankidOnDemandWidget = function getBankidOnDemandWidget(callWidgets) {
  return callWidgets && callWidgets.filter(notVersion2Widgets).find(function (widget) {
    return widget.get('url', '').includes('bankidagentview.jsp');
  });
};
export var getExternalSearchWidgets = function getExternalSearchWidgets(callWidgets) {
  return callWidgets && callWidgets.filter(notVersion2Widgets).filter(function (widget) {
    return !widget.get('url', '').includes('bankidagentview.jsp');
  });
};
var filterVersion2Widgets = function filterVersion2Widgets(include) {
  return function (widget) {
    return widget && (include ? !!widget.get('config') : !widget.get('config'));
  };
};
export var getVersion2Widgets = function getVersion2Widgets(callWidgets) {
  if (!callWidgets) {
    return [];
  } else {
    return callWidgets.filter(onlyVersion2Widgets).toList();
  }
};
export var getVersion1Widgets = function getVersion1Widgets(callWidgets) {
  if (!callWidgets) {
    return [];
  } else {
    return callWidgets.filter(notVersion2Widgets).valueSeq();
  }
};
export var notVersion2Widgets = function notVersion2Widgets(widget) {
  return filterVersion2Widgets(false)(widget);
};
export var onlyVersion2Widgets = function onlyVersion2Widgets(widget) {
  return filterVersion2Widgets(true)(widget);
};
export var getExternalSearchWidgetsForContextMenu = function getExternalSearchWidgetsForContextMenu(callWidgets) {
  return callWidgets && callWidgets.filter(function (widget) {
    var url = widget.get('url', '');
    return !url.includes('bankidagentview.jsp') && (url.includes('%NUMBER%') || url.includes('{NUMBER}') || url.includes("{".concat(CONTACT_BAG_VARIABLE_KEY)) || url.includes("%".concat(CONTACT_BAG_VARIABLE_KEY)));
  });
};

/**
 * Use this function to check if we should auto open call widget urls.
 * Note that this function does not open any urls, it just return a boolean
 * indicating if we should open any urls.
 */
export var shouldAutoOpenCallWidgetUrls = function shouldAutoOpenCallWidgetUrls(state, activeCall) {
  var ownActiveCalls = getOwnActiveCalls(state);
  var oldActiveCall = ownActiveCalls.filter(function (call) {
    return call.get('key') === activeCall.key;
  }).first();
  return !!oldActiveCall && oldActiveCall.get('direction') === ActiveCallDirections.INCOMING.value && !CallState.UP.is(oldActiveCall.get('state')) && CallState.UP.is(activeCall.state) && (oldActiveCall.get('source') !== undefined || activeCall.source !== undefined);
};

/**
 * For picked queue calls we don't want to open callwidgets until we have received the
 * QueueCallInfo event we get after the picked call has been connected. Then this
 * function should be used. The condtion for state === UP is to not open callwidgets too
 * early for regular queue calls, because then we get a QueueCallInfo event when the
 * queue makes a call attempt, before anyone answers.
 *
 * The reason we do this is because for picked calls we dont' receive the originalCallerId
 * until we get the QueueCallInfo, so before that we don't have a number to use in the widget.
 */
export var shouldAutoOpenCallWidgetUrlsForPickedQueueCall = function shouldAutoOpenCallWidgetUrlsForPickedQueueCall(state, activeCall) {
  var ownActiveCalls = getOwnActiveCalls(state);
  var oldActiveCall = ownActiveCalls.filter(function (call) {
    return call.get('key') === activeCall.key;
  }).first();
  return !!oldActiveCall && CallState.UP.is(oldActiveCall.get('state')) && (activeCall.source !== undefined || oldActiveCall.get('source') !== undefined);
};
export var addContactToBagVariables = function addContactToBagVariables(contactDTO, bagVariables) {
  var getContactAsBagVariable = function getContactAsBagVariable(contactDTO) {
    // Currently, we only add the contact as a bag variable if it's an integration contact.
    // NOTE: There is probably no danger with simply allowing any contact to be used in a widget.
    if (!contactDTO || !contactDTO.get('sourceId')) {
      return null;
    }
    var contact = contactDTO.toJS();
    if (typeof contact.metadata === 'string') {
      try {
        // Metadata is a string that may hold JSON data.
        // Try to parse it. If we fail, simply keep as is.
        contact.metadata = JSON.parse(contact.metadata);
      } catch (_e) {
        // Don't do anything. Leave metadata alone.
      }
    }
    return JSON.stringify(contact);
  };
  var contactBagVariable = getContactAsBagVariable(contactDTO);
  if (contactBagVariable) {
    var updatedBagVariables = bagVariables ? bagVariables : {};
    updatedBagVariables[CONTACT_BAG_VARIABLE_KEY] = contactBagVariable;
    return updatedBagVariables;
  } else {
    return bagVariables;
  }
};